import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Chip,
    Switch,
    Tooltip,
    colors
} from '@material-ui/core';

import { PageContext } from '../PageContext';

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    header: {
        color: colors.blueGrey[500],
        backgroundColor: colors.grey[200]
    },
}));

export const TableDetails = ({
    disabled,
    onToggleAvailability,
    onToggleAllowImport,
    onToggleClearOnImport,
    ...props }) => {
    const classes = useStyles();

    const {
        state
    } = useContext(PageContext);

    const {
        table
    } = state;

    const getUserNamesList = () => {
        if (table.users && table.users.length > 0) {
            return table.users.map((user, index) =>
                <span key={index}>{user.displayName};&nbsp;</span>
            )
        } else {
            return "No Members";
        }
    }

    const toggleAvailabilityClickHandler = (table) => {
        if (onToggleAvailability) onToggleAvailability(table);
    }

    const toggleAllowImportClickHandler = (table) => {
        if (onToggleAllowImport) onToggleAllowImport(table);
    }

    const toggleClearOnImportClickHandler = (table) => {
        if (onToggleClearOnImport) onToggleClearOnImport(table);
    }

    return (
        <Card className={clsx(classes.root, props.className)}>
            <CardHeader
                className={classes.header}
                title={
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>
                            <Typography variant="h6">
                                Table Info
                            </Typography>
                        </Grid>
                    </Grid>
                }
            />
            <CardContent>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell style={{ width: "20%" }}>
                                Name
                            </TableCell>
                            <TableCell>
                                {table.tableName}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Availability
                            </TableCell>
                            <TableCell>
                                <Tooltip title={table.isDisabled ? "Table is not available for management" : "Table is available for management"}>
                                    <span>
                                        <Switch
                                            checked={!table.isDisabled}
                                            onChange={() => toggleAvailabilityClickHandler(table)}
                                            name="isDisabled"
                                            disabled={disabled}
                                            inputProps={{ "aria-label": "is disabled checkbox" }}
                                        />
                                    </span>
                                </Tooltip>
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>
                                Allow Import
                            </TableCell>
                            <TableCell>
                                <Tooltip title={table.allowImport ? "Table allows data import" : "Table do not allow data import"}>
                                    <span>
                                        <Switch
                                            checked={table.allowImport}
                                            onChange={() => toggleAllowImportClickHandler(table)}
                                            name="allowImport"
                                            disabled={disabled}
                                            inputProps={{ "aria-label": "allow import checkbox" }}
                                        />
                                    </span>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Total Users
                            </TableCell>
                            <TableCell>
                                {table.users.length}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                All Users
                            </TableCell>
                            <TableCell>
                                {getUserNamesList()}
                            </TableCell>
                        </TableRow>
                        {table.roles && table.roles.map((role, index) =>
                        {
                            return <TableRow key={index}>
                                <TableCell>
                                    {role.groupName}
                                </TableCell>
                                <TableCell>
                                    {role.membersCount}
                                </TableCell>
                            </TableRow>
                        }
                        
                        )}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}